import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import {
  createRouteTransitionTimer,
  normalizeRouteForTelemetry,
} from '../../utils/instrumentation';

const requestAfterPaint = (callback) => {
  if (typeof window === 'undefined' || typeof window.requestAnimationFrame !== 'function') {
    callback();
    return null;
  }

  return window.requestAnimationFrame(() => {
    window.requestAnimationFrame(callback);
  });
};

const cancelAfterPaint = (frameId) => {
  if (frameId != null && typeof window !== 'undefined' && typeof window.cancelAnimationFrame === 'function') {
    window.cancelAnimationFrame(frameId);
  }
};

const RouteTransitionTracker = () => {
  const location = useLocation();
  const previousRouteRef = useRef(null);

  useEffect(() => {
    const currentRoute = normalizeRouteForTelemetry(location.pathname);
    const previousRoute = previousRouteRef.current;
    previousRouteRef.current = currentRoute;

    if (!previousRoute || previousRoute === currentRoute) {
      return undefined;
    }

    const finishTransition = createRouteTransitionTimer({
      from: previousRoute,
      to: currentRoute,
    });
    const frameId = requestAfterPaint(finishTransition);

    return () => cancelAfterPaint(frameId);
  }, [location.key, location.pathname]);

  return null;
};

export default RouteTransitionTracker;
